import React from 'react';
import { Button, Icon, Tooltip } from '@kajabi/sage-react';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';
import { CHAT_EVENT_TYPES } from 'common/components/CopyMagic/constants';
import useChatSessionId from 'common/components/CopyMagic/hooks/useChatSessionId';
import postChatEvent from 'common/components/CopyMagic/api/postChatEvent';
import openCustomerSupport from 'common/utils/openCustomerSupport';

const buttonText = 'Chat live with our support team';

const SupportButton = () => {
  const trackClicked = useGeneratorTrackingCallback('useTrackContactSupportClicked');
  const { getChatSessionId } = useChatSessionId();

  return (
    <Tooltip content={buttonText} position={Tooltip.POSITIONS.LEFT}>
      <Button
        color={Button.COLORS.SECONDARY}
        icon={Icon.ICONS.QUESTION_CIRCLE}
        iconOnly={true}
        subtle={true}
        onClick={() => {
          openCustomerSupport();
          trackClicked();
          postChatEvent({
            sessionId: getChatSessionId(),
            eventType: CHAT_EVENT_TYPES.TRANSFERRED_TO_SUPPORT,
          });
        }}
      >
        {buttonText}
      </Button>
    </Tooltip>
  );
};

export default SupportButton;
